import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import "./header.css";
import {
  AllFormsUpperphoto,
  Applogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Api_Url } from "../../config/config";
import { AuthContext } from "../../Context/AuthContext";

const Header = (props) => {
  const LeadsFetchFunction = props.LeadsFetchFunctionData;
  const UsereImage = props.usereImage;
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);

  const navigate = useNavigate();
  const { signout } = useContext(AuthContext);

  const HandleLogoutFunc = () => {
    signout();
    navigate("/");
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const themes = localStorage.getItem("theme");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };
  const handleProfile = async () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  const Credencial = sessionStorage.getItem("user");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.shortName;
  const ProfileName = UserName;

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? lnEnglish
        : lng === "fr"
        ? lnFrench
        : lng === "es"
        ? lnSpanish
        : lnGerman
    );
  };

  const id = JSON.parse(sessionStorage.getItem("user"))?.id;
  const [userprofile, setUserProfile] = useState("");

  useEffect(() => {
    const FetchImage = async (userId) => {
      try {
        const token = JSON.parse(sessionStorage.getItem("user"))?.accessToken;
        if (!token) {
          console.error("No token found in session storage.");
          return;
        }
        
        const response = await axios.get(`${Api_Url}api/v1/UserProfile/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        // Check if data exists
        if (response.data?.data) {
          setUserProfile(response.data.data);
        } else {
          console.warn("No user data returned.");
        }
  
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      }
    };
  
    if (id) {
      FetchImage(id);
    }
  }, [id]);
  

  return (
    <>
      <div className="header" style={{ right: "0px" }}>
        {/* Logo */}
        <div className="header-left">
          {/* <BackButton className="back-button" /> */}
          <Link to="/employee-dashboard">
            <img className="logo" src={Applogo} alt="img" />
          </Link>
          <Link to="/admin-dashboard" className="logo2">
            <img src={Applogo} width={70} height={70} alt="img" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="toggle_btn"
          to="#"
          style={{
            display: pathname.includes("tasks")
              ? "none"
              : pathname.includes("compose")
              ? "none"
              : "",
          }}
          onClick={handlesidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Title */}
        <div className="page-title-box">
          <h3>ROHA Housing Finance</h3>
        </div>
        {/* /Header Title */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={() => onMenuClik()}
        >
          <i className="fa fa-bars" />
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          <li>
            <Link to="/roles" style={{ color: "white" }}>
              <i className="fa-solid fa-arrows-rotate"></i>
            </Link>
          </li>
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              onClick={handleProfile}
            >
              <span className="user-img me-1 ">
                <img
                  className="img-fluid MyuserProfile"
                  src={userprofile?.profileImageUrl ? userprofile?.profileImageUrl : AllFormsUpperphoto}
                  // src={userprofile?.profileImageUrl}
                  alt="img"
                />
                <span className="status online" />
              </span>
              <span>{ProfileName ? `${ProfileName}` : "Admin"}</span>
            </Link>
            <div
              className={`dropdown-menu dropdown-menu-end ${
                profile ? "show" : ""
              }`}
            >
              <Link className="dropdown-item" to="/profile">
                My Profile
              </Link>
              <Link className="dropdown-item" onClick={() => HandleLogoutFunc()}>
                Logout
              </Link>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
            <Link className="dropdown-item" to="/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/roles">
              Roles
            </Link>
            <Link className="dropdown-item" onClick={() => HandleLogoutFunc()}>
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
